/** Native details retain their own accessible expanded state and keyboard behavior. */
class SnoozeFooter extends HTMLElement {
  connectedCallback() {
    this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
  }
  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const desktop = matchMedia('(min-width:990px)');
    const groups = [...this.querySelectorAll('details.snooze-footer__group')];
    const state = new Map(groups.map((g) => [g, this.dataset.mobileOpen === 'true']));
    const forcedOpen = () => desktop.matches || this.dataset.mobileLayout === 'stacked';
    const update = () => {
      for (const group of groups) {
        group.open = forcedOpen() || state.get(group);
        // Desktop/stacked headings are not presented as interactive disclosures.
        group.querySelector('summary')?.setAttribute('tabindex', forcedOpen() ? '-1' : '0');
      }
    };
    update();
    desktop.addEventListener('change', update, { signal });
    for (const group of groups) {
      group.addEventListener('toggle', () => { if (!forcedOpen()) state.set(group, group.open); }, { signal });
      group.querySelector('summary')?.addEventListener('click', (event) => { if (forcedOpen()) event.preventDefault(); }, { signal });
    }
    document.addEventListener('shopify:block:select', (event) => {
      const group = groups.find((g) => g.matches(`[data-shopify-editor-block*='"id":"${CSS.escape(event.detail?.blockId || '')}"']`));
      if (group && !forcedOpen()) { state.set(group, true); group.open = true; }
    }, { signal });
  }
  disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
}
if (!customElements.get('snooze-footer')) customElements.define('snooze-footer', SnoozeFooter);
